import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { blue } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';

interface Props {}

export const PanelFormStyled = ({ children }: PropsWithChildren<Props>) => {
  const classes = useStyles();

  return <Box className={classes.formContainer}>{children}</Box>;
};

const useStyles = makeStyles(({ palette: { primary } }) => ({
  formContainer: {
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',

    '& .productName': {
      textTransform: 'capitalize',
    },

    '& .row': {
      gap: '8px',
      display: 'flex',

      '& > *': {
        flex: 1,
        maxWidth: '50%',
      },
    },

    '& .section': {
      gap: '6px',
      display: 'flex',
      flexDirection: 'column',

      '& .actions': {
        gap: '2px',
        display: 'flex',
        alignItems: 'center',
      },

      '& .sectionHeader': {
        display: 'flex',
        minHeight: '56px',
        borderRadius: '2px',
        position: 'relative',
        padding: '13px 16px',
        alignItems: 'center',
        backgroundColor: blue['50'],
        justifyContent: 'space-between',

        '& .collapse': {
          gap: '8px',
          display: 'flex',
          alignItems: 'center',
        },

        '& .actionPanel': {
          gap: '8px',
          display: 'flex',
          alignItems: 'center',
        },

        '& .MuiButton-contained': {
          color: primary.main,
          borderRadius: 'var(--borderRadius, 4px)',
          background: 'var(--common-white_states-main, #FFF)',
          boxShadow:
            '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)',
          '&.Mui-disabled': {
            boxShadow: 'none',
            color: primary.light,
          },
        },
      },

      '& .sectionFields': {
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',
      },
    },

    '& .sectionHidden': {
      height: 0,
      visibility: 'hidden',
    },
  },
}));
